import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getCountsWithComma } from '../../../../commons/util/utilities';
import { Options } from './graphOptions';
import SkeletonLoader from '../../../../components/SkeletonLoader';
import { buildChartTooltip } from '../chartTooltip';
import { useChartTooltipStyles as useStyles } from '../chartTooltip/styles';

export default function Charts (props) {
  const classes = useStyles();
  const [values, setValues] = useState([]);
  const [options, setOptions] = useState(Options);

  const calendarTypes = props.data;

  const capitalizeFirstChar = (text) => text[0]?.toUpperCase() + text.slice(1);

  const getCategories = (data) => data.map(({ type }) => (
      (type === 'ics_other' && 'ICS') ||
      (type === 'windowslive' && 'Outlook.com (Web)') ||
      (type === 'office365' && 'Microsoft 365') ||
      (!type && 'Other') ||
      capitalizeFirstChar(type)
  ));
  const getValues = (data) => data.map(({ count }) => count);

  useEffect(() => {
    if (calendarTypes?.length) {
      const sortedData = [...calendarTypes].sort((a, b) => b.count - a.count);
      const newSortedData = JSON.stringify(sortedData);
      const formattedData = getCountsWithComma(JSON.parse(newSortedData));
      const categories = getCategories(sortedData);
      setOptions({
        ...options,
        xaxis: { categories },
        tooltip: {
          ...options.tooltip,
          custom: ({ dataPointIndex }) => {
            const point = formattedData?.[dataPointIndex];
            if (!point) return '';
            return buildChartTooltip({
              label: categories?.[dataPointIndex] ?? '',
              count: point.count,
              sublabel: 'Subs',
            });
          },
        },
      });
      setValues([{ data: getValues(sortedData) }]);
     }
  }, [calendarTypes]);

  return (
    <>
      { props.isLoading && !calendarTypes?.length
? (
        <SkeletonLoader />
      )
: (
      <div className={classes.chartWrapper}>
        <ReactApexChart
          options={options}
          series={values}
          type='bar'
          height='350'
        />
      </div>
      )}
    </>
  );
}
